import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Card, { CardContent } from 'material-ui/Card';
import Typography from 'material-ui/Typography';
import Chart from './charts/Chart';
import classNames from 'classnames';
import { numberFormatTwoFractions } from '../helper/dateFormat';
import { API_RESPONSE_NO_DATA } from '../constants/actionMessages';

const styles = theme => ({
  card: {
    minWidth: 275,
    position: 'relative',
    marginBottom: '1rem'
  },
  title: {
    marginBottom: 16,
    fontSize: 14
  },
  pos: {
    marginBottom: 12,
    color: theme.palette.text.secondary
  },
  chart__headline: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'white',
    opacity: 0.7,
    zIndex: 100,
    transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'
  },
  overlayLoading: {
    '&:after': {
      content: "'...Loading Data'",
      position: 'absolute',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      opacity: 1,
      transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'
    }
  },
  overlayEmptyResponse: {
    '&:after': {
      content: `"${API_RESPONSE_NO_DATA}"`,
      position: 'absolute',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      opacity: 1,
      transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms'
    }
  }
});

const ChartCard = ({
  chartOptions,
  timeSeries,
  utcOffset,
  queryParams,
  updateQueryParams,
  classes,
  loading,
  emptyResponse,
  external
}) => (
  <Card className={classes.card}>
    {emptyResponse ? (
      <div
        className={classNames(classes.overlay, classes.overlayEmptyResponse)}
      />
    ) : null}
    {loading ? (
      <div className={classNames(classes.overlay, classes.overlayLoading)} />
    ) : null}
    <CardContent>
      <div className={classes.chart__headline}>
        <Typography type="title" className={classes.title}>
          {timeSeries.name}
        </Typography>

        <Typography type="body1" className={classes.title}>
          {timeSeries.sum.energy
            ? `${numberFormatTwoFractions.format(timeSeries.sum.energy)} kWh`
            : null}
        </Typography>
      </div>
      <Chart
        chartOptions={chartOptions}
        timeSeries={timeSeries}
        utcOffset={utcOffset}
        queryParams={queryParams}
        updateQueryParams={updateQueryParams}
        external={external}
      />
    </CardContent>
  </Card>
);

ChartCard.propTypes = {
  classes: PropTypes.object.isRequired,
  chartOptions: PropTypes.object.isRequired
};

export default withStyles(styles, { name: 'ChartCard' })(ChartCard);



// WEBPACK FOOTER //
// ./src/components/ChartCard.js